import * as angular from 'angular';

import * as constants from '../../common/constants';
import { ILoggerService } from '../general/logger.service';

export interface ISessionStorageService {
    clearApplicationData(): void;
    getFrom: (key: string) => any;
    getTypedFrom<T>(key: string): T;
    remove: (key: string) => boolean;
    setTo: (key: string, object: any) => boolean;
    setTypedTo<T>(key: string, data: T): boolean;
}

export class SessionStorageService implements ISessionStorageService {
    static serviceId = 'sessionStorageService';

    static $inject = ['$window', 'loggerService'];
    constructor(private _$window: angular.IWindowService,
        private _loggerService: ILoggerService) {

    }

    setTo(key: string, data: string): boolean {
        try {
            this._$window.sessionStorage.setItem(key, data);
            return true;
        } catch (reason) {
            this._loggerService.logError(reason);
            return false;
        }
    }

    setTypedTo<T>(key: string, data: T): boolean {
        const toStore = JSON.stringify(data);
        if (this.getTypedFrom<T>(key)) {
            this.remove(key);
        }
        return this.setTo(key, toStore);
    }

    getFrom(key: string): any {
        try {
            const item = this._$window.sessionStorage.getItem(key);
            return item;
        } catch (reason) {
            this._loggerService.logError(reason);
            return null;
        }
    }

    getTypedFrom<T>(key: string): T {
        const fromStore = this.getFrom(key);
        return <T>JSON.parse(fromStore);
    }

    remove(key: string): boolean {
        try {
            this._$window.sessionStorage.removeItem(key);
            return true;
        } catch (reason) {
            this._loggerService.logError(reason);
            return false;
        }
    }

    clearApplicationData(): void {
        const authorizationData = this.getFrom(constants.authorizationDataKey);
        this._$window.sessionStorage.clear();
        this.setTo(constants.authorizationDataKey, authorizationData);
    }
}